import React from "react";
import { Link } from "react-router-dom";
import { FaPaperPlane, FaTelegramPlane } from "react-icons/fa";
import { FaMapMarkerAlt, FaEnvelopeOpen, FaFacebookF } from "react-icons/fa";
import { AiOutlineGoogle } from "react-icons/ai";
import { BsTwitter, BsInstagram } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import { contacts } from "../../../utils/contact";
import "./style.css";

import logo from "../../../assets/icons/logo-dark1.svg";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <>
      <footer className="theme-dark-bg">
        <div className="tp-footer-area-two pt-80 pb-50">
          <div className="container" id="contacts">
            <div className="row">
              <div className="col-lg-2"></div>
              <div className="col-lg-4 col-sm-6">
                <div
                  className="tp-footer-widget footer-col-1 mb-30 wow fadeInUp"
                  data-wow-delay=".3s"
                >
                  <div className="tp-footer-info">
                    <div className="tp-footer-info-logo mb-35">
                      <Link to="/">
                        <img
                          src={logo}
                          className="img-fluid"
                          alt="img not found"
                        />
                      </Link>
                    </div>
                    <h4 className="mb-15">
                      <a href={`tel:${contacts.tel.replaceAll(" ", "")}`}>
                        {contacts.tel}
                      </a>
                      <br />
                      <a href={`tel:${contacts.tel2.replaceAll(" ", "")}`}>
                        {contacts.tel2}
                      </a>
                    </h4>
                    <h6 className="mb-15">
                      {" "}
                      <i>
                        {" "}
                        <FaEnvelopeOpen />{" "}
                      </i>
                      <a href={`mailto:${contacts.email}`}>{contacts.email}</a>
                    </h6>
                    <div className="tp-footer-info-social">
                      <a href={contacts.telegramLink}>
                        <i>
                          <FaTelegramPlane className="icon" />{" "}
                        </i>
                      </a>
                      <a href={contacts.instagramLink}>
                        <i>
                          <BsInstagram className="icon" />{" "}
                        </i>
                      </a>
                      <a href={contacts.telegramLink}>
                        <i>
                          <FaFacebookF className="icon" />{" "}
                        </i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div
                  className="tp-footer-widget footer-col-2 mb-30 wow fadeInUp"
                  data-wow-delay=".6s"
                >
                  <h4 className="tp-footer-widget-title mb-35">
                    {t("Footer.OurServices")}
                  </h4>
                  <ul>
                    <li>
                      <a href="#">{t("Footer.Carpet")}</a>
                    </li>
                    <li>
                      <a href="#">{t("Footer.Plumbing")}</a>
                    </li>
                    <li>
                      <a href="#">{t("Footer.ParkClear")} </a>
                    </li>
                    <li>
                      <a href="#">{t("Footer.Residential")}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tp-copyright-area-two bg-green-light z-index pt-30 pb-30">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="tp-copyright tp-copyright-two text-center">
                  <p className="m-0">
                    {t("Footer.Copyright")}
                    {new Date().getFullYear()} <span>{t("Footer.Apps")}</span>.
                    {t("Footer.AllRightsReserved")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
